import './App.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Quote from './pages/Quote.js';
import { store } from "./store";
import { Provider } from 'react-redux';
import ProtectedRoutes from './utils/ProtectedRoutes';

import AgentHome from './pages/home/AgentHome.js';
import CustomerHome from './pages/home/CustomerHome.js';
import DepotUserHome from './pages/home/DepotUserHome.js';
import SalesHome from './pages/home/SalesHome.js';
import SurveyorHome from './pages/home/SurveyorHome.js';


// Admin Masters
import AgentMaster from './pages/master/admin/AgentMaster.js';
import BankAccountMaster from './pages/master/admin/BankAccountMaster.js';
import CFSMaster from './pages/master/admin/CFSMaster.js';
import ChargesMaster from './pages/master/admin/ChargesMaster.js';
import CurrencyExchangeRateMaster from './pages/master/admin/CurrencyExchangeRateMaster.js';
import DepotMaster from './pages/master/admin/DepotMaster.js';
import MessageMaster from './pages/master/admin/MessageMaster.js';
import NotificationTemplateGroupMaster from './pages/master/admin/NotificationTemplateGroupMaster.js';
import OperatorMaster from './pages/master/admin/OperatorMaster.js';
import OwnerMaster from './pages/master/admin/OwnerMaster.js';
import PortMaster from './pages/master/admin/PortMaster.js';
import PrincipalMaster from './pages/master/admin/PrincipalMaster.js';
import ProductMaster from './pages/master/admin/ProductMaster.js';
import QueueMaster from './pages/master/admin/QueueMaster.js';
import RoleMaster from './pages/master/admin/RoleMaster.js';
import RolePermissionMaster from './pages/master/admin/RolePermissionMaster.js';
import SalesTeamMaster from './pages/master/admin/SalesTeamMaster.js';
import SurveyorMaster from './pages/master/admin/SurveyorMaster.js';
import TaskMaster from './pages/master/admin/TaskMaster.js';
import TerminalVendorMaster from './pages/master/admin/TerminalVendorMaster.js';
import UploadGroupMaster from './pages/master/admin/UploadGroupMaster.js';
import UserMaster from './pages/master/admin/UserMaster';


// Masters
import CargoNameMaster from './pages/master/CargoNameMaster.js';
import CustomerMaster from './pages/master/CustomerMaster.js';
import CustomerBranchMaster from './pages/master/CustomerBranchMaster.js';
import DeadFrightVesselMaster from './pages/master/DeadFreightVesselMaster.js';
import PackageTypeMaster from './pages/master/PackageTypeMaster.js';
import ProjectMaster from './pages/master/ProjectMaster.js';
import VesselMaster from './pages/master/VesselMaster.js';
import VesselScheduleMaster from './pages/master/VesselScheduleMaster.js';
import VesselServiceMaster from './pages/master/VesselServiceMaster.js';
import DepartmentMaster from './pages/master/DepartmentMaster.js';
import DesignationMaster from './pages/master/DesignationMaster.js';
import AssetTypeMaster from './pages/master/AssetTypeMaster.js';
import HolidayMaster from './pages/master/HolidayMaster.js';
import LeaveTypeMaster from './pages/master/LeaveTypeMaster.js';

// Shipment Exports
import PlannedExport from './pages/shipment/export/PlannedExport.js';
import SobBooking from './pages/shipment/export/SobBooking.js';
import ClosedBooking from './pages/shipment/export/ClosedBooking.js';
import CancelledBooking from './pages/shipment/export/CancelledBooking.js';
import ExportReport from './pages/shipment/export/ExportReport.js';
import LoadList from './pages/shipment/export/LoadList.js';

// Shipment Imports
import PlannedImport from './pages/shipment/import/PlannedImport.js';
import ArrivedImport from './pages/shipment/import/ArrivedImport.js';
import ImportReport from './pages/shipment/import/ImportReport.js';

// Shipment Transhipments
import PlannedTranshipment from './pages/shipment/transhipment/PlannedTranshipment.js';
import ArrivedTranshipment from './pages/shipment/transhipment/ArrivedTranshipment.js';
import DepartedTranshipment from './pages/shipment/transhipment/DepartedTranshipment.js';
import TranshipmentReport from './pages/shipment/transhipment/TranshipmentReport.js';


// Inventory
import Container from './pages/inventory/Container.js';
import ContainerSummary from './pages/inventory/ContainerSummary.js';
import EmployeeList from './pages/hr/EmployeeList.js';
import EmployeeDetail from './pages/hr/EmployeeDetail.js';
import AttendanceLeave from './pages/hr/AttendanceLeave.js';
import PayrollManagement from './pages/hr/PayrollManagement.js';
import AssetManagement from './pages/hr/AssetManagement.js';
import AssetDetail from './pages/hr/AssetDetail.js';


// Sales
import SalesCustomer from './pages/sales/SalesCustomer.js';


// Rate Sheet
import SlotRateSheet from './pages/ratesheet/SlotRateSheet.js';
import SlotAgreement from './pages/ratesheet/SlotAgreement.js';


// Draft Booking
import Shipment from './pages/draftbooking/Shipment.js';
import DraftBookingRequest from './pages/draftbooking/DraftBookingRequest.js';
import DraftBookingRequestCustomer from './pages/draftbooking/DraftBookingRequestCustomer.js';
import ApprovedDraftBooking from './pages/draftbooking/ApprovedDraftBooking.js';
import ManageTariff from './pages/draftbooking/ManageTariff.js';
import TariffCharge from './pages/draftbooking/TariffCharge.js';
import TariffCosting from './pages/draftbooking/TariffCosting.js';
import TaskManagement from './pages/draftbooking/TaskManagement.js';



const router = createBrowserRouter(
  [
    {
      path: "/",
      element: sessionStorage.getItem('token') ? <Dashboard /> : <Login />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/getaquote",
      element: <Quote />,
      errorElement: <ErrorPage />,
    },
    {
      element: <ProtectedRoutes />,
      children: [
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
        // Admin Master Routes
        {
          path: "/master/admin/agent",
          element: <AgentMaster />,
        },
        {
          path: "/master/admin/bankaccount",
          element: <BankAccountMaster />,
        },
        {
          path: "/master/admin/cfs",
          element: <CFSMaster />,
        },
        {
          path: "/master/admin/charges",
          element: <ChargesMaster />,
        },
        {
          path: "/master/admin/currencyexchangerate",
          element: <CurrencyExchangeRateMaster />,
        },
        {
          path: "/master/admin/depot",
          element: <DepotMaster />,
        },
        {
          path: "/master/admin/message",
          element: <MessageMaster />,
        },
        {
          path: "/master/admin/notificationtemplategroup",
          element: <NotificationTemplateGroupMaster />,
        },
        {
          path: "/master/admin/operator",
          element: <OperatorMaster />,
        },
        {
          path: "/master/admin/owner",
          element: <OwnerMaster />,
        },
        {
          path: "/master/admin/port",
          element: <PortMaster />,
        },
        {
          path: "/master/admin/principal",
          element: <PrincipalMaster />,
        },
        {
          path: "/master/admin/product",
          element: <ProductMaster />,
        },
        {
          path: "/master/admin/queue",
          element: <QueueMaster />,
        },
        {
          path: "/master/admin/role",
          element: <RoleMaster />,
        },
        {
          path: "/master/admin/rolepermission",
          element: <RolePermissionMaster />,
        },
        {
          path: "/master/admin/salesteam",
          element: <SalesTeamMaster />,
        },
        {
          path: "/master/admin/surveyor",
          element: <SurveyorMaster />,
        },
        {
          path: "/master/admin/task",
          element: <TaskMaster />,
        },
        {
          path: "/master/admin/terminalvendor",
          element: <TerminalVendorMaster />,
        },
        {
          path: "/master/admin/uploadgroup",
          element: <UploadGroupMaster />,
        },
        {
          path: "/master/admin/user",
          element: <UserMaster />,
        },

        // Master Routes
        {
          path: "/master/cargoname",
          element: <CargoNameMaster />,
        },
        {
          path: "/master/customer",
          element: <CustomerMaster />,
        },
        {
          path: "/master/customerbranch",
          element: <CustomerBranchMaster />,
        },
        {
          path: "/master/deadfreightvessel",
          element: <DeadFrightVesselMaster />,
        },
        {
          path: "/master/packagetype",
          element: <PackageTypeMaster />,
        },
        {
          path: "/master/project",
          element: <ProjectMaster />,
        },
        {
          path: "/master/vessel",
          element: <VesselMaster />,
        },
        {
          path: "/master/vesselschedule",
          element: <VesselScheduleMaster />,
        },
        {
          path: "/master/vesselservice",
          element: <VesselServiceMaster />,
        },
        {
          path: "/master/department",
          element: <DepartmentMaster />,
        },
        {
          path: "/master/designation",
          element: <DesignationMaster />,
        },
        {
          path: "/master/assettype",
          element: <AssetTypeMaster />,
        },
        {
          path: "/master/holiday",
          element: <HolidayMaster />,
        },
        {
          path: "/master/leavetype",
          element: <LeaveTypeMaster />,
        },

        {
          path: "/agenthome",
          element: <AgentHome />,
        },
        {
          path: "/customerhome",
          element: <CustomerHome />,
        },
        {
          path: "/depotuserhome",
          element: <DepotUserHome />,
        },
        {
          path: "/saleshome",
          element: <SalesHome />,
        },
        {
          path: "/surveyorhome",
          element: <SurveyorHome />,
        },

        // Shipment Export Routes
        {
          path: "/shipment/plannedexports",
          element: <PlannedExport />,
        },
        {
          path: "/shipment/sobbooking",
          element: <SobBooking />,
        },
        {
          path: "/shipment/closedbooking",
          element: <ClosedBooking />,
        },
        {
          path: "/shipment/cancelledbooking",
          element: <CancelledBooking />,
        },
        {
          path: "/shipment/exportreport",
          element: <ExportReport />,
        },
        {
          path: "/shipment/loadlist",
          element: <LoadList />,
        },

        // Shipment Import Routes
        {
          path: "/shipment/plannedimports",
          element: <PlannedImport />,
        },
        {
          path: "/shipment/arrivedimports",
          element: <ArrivedImport />,
        },
        {
          path: "/shipment/importreport",
          element: <ImportReport />,
        },

        // Shipment Transhipment Routes
        {
          path: "/shipment/plannedtranshipment",
          element: <PlannedTranshipment />,
        },
        {
          path: "/shipment/arrivedtranshipment",
          element: <ArrivedTranshipment />,
        },
        {
          path: "/shipment/departedtranshipment",
          element: <DepartedTranshipment />,
        },
        {
          path: "/shipment/transhipmentreport",
          element: <TranshipmentReport />,
        },

        // Inventory Routes
        {
          path: "/inventory/containersummary",
          element: <ContainerSummary />,
        },
        {
          path: "/inventory/container",
          element: <Container />,
        },

        // HR Routes
        {
          path: "/hr/employee",
          element: <EmployeeList />,
        },
        {
          path: "/hr/employee/:userId",
          element: <EmployeeDetail />,
        },
        {
          path: "/hr/attendanceleave",
          element: <AttendanceLeave />,
        },
        {
          path: "/hr/payroll",
          element: <PayrollManagement />,
        },
        {
          path: "/hr/asset",
          element: <AssetManagement />,
        },
        {
          path: "/hr/asset/:assetId",
          element: <AssetDetail />,
        },

        // Sales Routes
        {
          path: "/sales/customer",
          element: <SalesCustomer />,
        },

        // Rate Sheet Routes
        {
          path: "/ratesheet/slotratesheet",
          element: <SlotRateSheet />,
        },

        {
          path: "/ratesheet/slotagreement",
          element: <SlotAgreement />,
        },

        // Draft Booking Routes
        {
          path: "/draftbooking/shipment",
          element: <Shipment />,
        },
        {
          path: "/draftbooking/draftbookingrequest",
          element: <DraftBookingRequest />,
        },
        {
          path: "/draftbooking/draftbookingrequest/:id",
          element: <DraftBookingRequest />,
        },
        {
          path: "/draftbooking/customerdraftbookingrequest",
          element: <DraftBookingRequestCustomer />,
        },
        {
          path: "/draftbooking/customerdraftbookingrequest/:id",
          element: <DraftBookingRequestCustomer />,
        },
        {
          path: "/draftbooking/approveddraftbooking",
          element: <ApprovedDraftBooking />,
        },
        {
          path: "/draftbooking/managetariff",
          element: <ManageTariff />,
        },
        {
          path: "/draftbooking/managetariffcharge",
          element: <TariffCharge />,
        },
        {
          path: "/draftbooking/tariffcosting",
          element: <TariffCosting />,
        },
        {
          path: "/draftbooking/taskmanagement",
          element: <TaskManagement />,
        },
      ]
    }
  ]

);

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <RouterProvider router={router} />
      </div>
    </Provider>
  );
}

export default App;
